<template>
  <el-drawer
    title="Add New Beneficiary"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
  >
    <div class="w-full h-screen">
      <div class="w-full bg-root">
        <div class="px-4 lg:px-8 pb-8">
          <ngn-payout-beneficiary-form
            v-if="currencyIsNGN"
            @next="addNewBeneficiary"
            :isSavingBeneficiary="isSavingBeneficiary"
          />
          <foreign-payout-beneficiary-form
            v-if="!transferDestinationIsLocal"
            @next="addNewBeneficiary"
            :isSavingBeneficiary="isSavingBeneficiary"
          />
          <mobile-money-payout-beneficiary-form
            v-if="isMobileMoneyPayoutForm || isXofMnoForm"
            @next="addNewBeneficiary"
            :isSavingBeneficiary="isSavingBeneficiary"
          />
          <bank-transfer-payout-beneficiary-form
            v-if="isBankTransferPayoutMethod && !isXofMnoForm"
            @next="addNewBeneficiary"
            :isSavingBeneficiary="isSavingBeneficiary"
          />
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import bulkPayout from '@/mixins/bulkPayout'

export default {
  mixins: [bulkPayout],
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    paymentType: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      isSavingBeneficiary: false
    }
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    isMobileMoneyPayoutForm () {
      return (
        this.mobileWalletSupportedCurrencies && this.isMobileMoneyPayoutMethod
      )
    },
    isXofMnoForm () {
      return (
        (this.currencyIsXOF || this.currencyIsXAF) && this.paymentType === 'mno'
      )
    }
  },
  components: {
    NgnPayoutBeneficiaryForm: () =>
      import('@/components/v2/bulkPayout/forms/NgnPayoutBeneficiaryForm.vue'),
    ForeignPayoutBeneficiaryForm: () =>
      import(
        '@/components/v2/bulkPayout/forms/ForeignPayoutBeneficiaryForm.vue'
      ),
    MobileMoneyPayoutBeneficiaryForm: () =>
      import(
        '@/components/v2/bulkPayout/forms/MobileMoneyPayoutBeneficiaryForm.vue'
      ),
    BankTransferPayoutBeneficiaryForm: () =>
      import(
        '@/components/v2/bulkPayout/forms/BankTransferPayoutBeneficiaryForm.vue'
      )
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    },
    addNewBeneficiary (recipientInfo) {
      this.saveBeneficiary(recipientInfo)
    }
  }
}
</script>

<style scoped>
* >>> .el-drawer__header > :first-child {
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 600;
}
* >>> .el-drawer__header {
  color: var(--text-4);
  font-size: 1.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.4rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-2);
}
* >>> .el-drawer {
  background: var(--background-9) !important;
}
</style>
